<template>
    <div
            class="flex justify-between py-2 px-4 border-l-4"
            v-bind:style="'border-color:' + item.color"
            v-bind:id="index"
    >
        <div class="flex-none"></div>

        <div class="flex-grow flex">
            <div class="flex-grow">
                <div class="flex justify-between">
                    <div class="w-2/3 overflow-hidden h-4">
                        <edit-series v-slot:default="slotProps" :item="item" :index="index">
                            <a @click="slotProps.open" class="cursor-pointer overflow-hidden" v-bind:name="item.name">
                                {{ item.name }}
                            </a>
                        </edit-series>
                    </div>

                    <div class="text-grey-dark" :class="{'text-green-dark': tendency > 0, 'text-red-lighter': tendency < 0}">
                        {{ latest }} <i class="fa" :class="{'fa-arrow-up': tendency > 0, 'fa-arrow-down': tendency < 0}"></i>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import EditSeries from "./EditSeries";

    export default {

        components: {EditSeries},

        props: ['item', 'index'],

        computed: {
            latest() {
                let items = this.item.data;

                return items[items.length - 1].value;
            },
            tendency() {
                let items = this.item.data;

                if (items[items.length - 2] === undefined) {
                    return 0;
                }

                return (items[items.length - 1].value) - (items[items.length - 2].value);
            },
        },
    }
</script>
